import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/calendar'),
      name: 'calendar_index',
      meta: {
        permissions: ['administrator', 'agent', 'calendar_manage'],
        featureFlag: FEATURE_FLAGS.CALENDAR,
      },
      component: () => import('./CalendarIndex.vue'),
    },
  ],
};
